<template>
  <div class="page-container">
    <div class="header-bar">
      <span class="header-back" @click="$router.back()">←</span>
      收货地址
    </div>

    <div class="address-list">
      <div
        v-for="address in addressList"
        :key="address.id"
        class="address-card"
        :class="{ 'is-default': address.isDefault }"
        @click="editAddress(address)"
      >
        <div class="address-content">
          <div class="address-header">
            <div class="contact-info">
              <span class="name">{{ address.name }}</span>
              <span class="phone">{{ address.phone }}</span>
              <el-tag v-if="address.isDefault" size="mini" type="danger" effect="dark">
                默认
              </el-tag>
            </div>
          </div>
          <div class="address-detail">
            {{ address.province }}{{ address.city }}{{ address.district }}{{ address.detail }}
          </div>
        </div>

        <div class="address-actions" @click.stop>
          <button
            v-if="!address.isDefault"
            class="action-link set-default"
            @click="setDefault(address)"
          >
            设为默认
          </button>
          <button
            class="action-link delete-btn"
            @click="deleteAddress(address)"
          >
            删除
          </button>
        </div>
      </div>

      <div v-if="addressList.length === 0" class="empty-state">
        <i class="el-icon-location-outline empty-icon"></i>
        <p>暂无收货地址</p>
        <p class="empty-tip">点击右下角按钮添加新地址</p>
      </div>
    </div>

    <button class="fab-button" @click="addAddress">+</button>
  </div>
</template>

<script>
import { getAddressList, deleteAddress, setDefaultAddress } from '../api/address'

export default {
  name: 'AddressList',
  data() {
    return {
      loading: false,
      addressList: []
    }
  },
  created() {
    this.loadAddressList()
  },
  methods: {
    async loadAddressList() {
      this.loading = true
      const loadingInstance = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.9)'
      })

      try {
        const res = await getAddressList()
        const list = res.data && res.data.list ? res.data.list : []
        this.addressList = list.map(item => ({
          id: item.id,
          name: item.consignee_name,
          phone: item.consignee_phone,
          province: item.province,
          city: item.city,
          district: item.district,
          detail: item.detail_address,
          isDefault: !!item.is_default
        }))
      } catch (error) {
        console.error('加载地址列表失败:', error)
      } finally {
        this.loading = false
        if (loadingInstance) {
          loadingInstance.close()
        }
      }
    },
    addAddress() {
      this.$router.push('/address/edit')
    },
    editAddress(address) {
      this.$router.push(`/address/edit/${address.id}`)
    },
    async setDefault(address) {
      try {
        const res = await setDefaultAddress(address.id)
        this.addressList.forEach(item => {
          item.isDefault = item.id === address.id
        })
        this.$message.success(res.msg || '操作成功')
      } catch (error) {
        console.error('设置默认地址失败:', error)
        this.$message.error(error.msg || error.message || '操作失败')
      }
    },
    deleteAddress(address) {
      this.$confirm('确定删除该收货地址吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteAddress(address.id)

          const index = this.addressList.findIndex(item => item.id === address.id)
          if (index > -1) {
            this.addressList.splice(index, 1)
          }

          this.$message.success(res.msg || '操作成功')
        } catch (error) {
          console.error('删除地址失败:', error)
          this.$message.error(error.msg || error.message || '操作失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  padding-bottom: 80px;
}

.address-list {
  padding: 12px 16px;
}

.address-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
}

.address-card.is-default {
  border-left-color: #409EFF;
}

.address-card:active {
  transform: scale(0.98);
}

.address-content {
  margin-bottom: 12px;
}

.address-header {
  margin-bottom: 10px;
}

.contact-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.phone {
  font-size: 14px;
  color: #606266;
}

.address-detail {
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
  padding-left: 2px;
}

.address-actions {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.action-link {
  background: none;
  border: none;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
  transition: all 0.2s;
  font-family: inherit;
}

.set-default {
  color: #409EFF;
}

.set-default:hover {
  color: #66b1ff;
}

.delete-btn {
  color: #f56c6c;
}

.delete-btn:hover {
  color: #f78989;
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #c0c4cc;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state p {
  font-size: 15px;
  margin-bottom: 8px;
}

.empty-tip {
  font-size: 13px !important;
}
</style>